import Divider from "../../components/divider/Divider";
import FooterCTA from "../../components/footerCTA/FooterCTA";
import Transition from "../../components/transition/Transition";
import ProjectHero from "./projectHero/ProjectHero";
import ProjectList from "./projectList/ProjectList";

export default function Projects(){


    return(
        <Transition emojiName="hammer">

            <ProjectHero />

            <Divider />

            <ProjectList />

            <Divider />

            <FooterCTA />

        </Transition>
    );
}